// The nav-menu API labels this group "Statement of good health". The nav shows the
// parent item's label instead, and the footer shows no sub-heading.
export const STATEMENT_OF_GOOD_HEALTH_GROUP_ID = 'STATEMENT_OF_GOOD_HEALTH';
